<aw-dialog
  (onClose)="dialogRef.close($event)"
  [content]="content"
  [isValid]="newLanguageForm.valid"
  [width]="width"
  [data]="data"
  [title]="data.headline">
  <ng-template #content>
    <div class="flex flex-col gap-4">
      <aw-text-input
        class="w-full"
        [id]="'sprache'"
        [formControl]="newLanguageForm.controls.name"
        [label]="cmsTextProvider.shared.language" />
      <aw-text-input
        class="w-full"
        [id]="'prefix'"
        [formControl]="newLanguageForm.controls.prefix"
        [label]="cmsTextProvider.shared.abbreviation" />
    </div>
  </ng-template>
</aw-dialog>
